
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8kTwy", function(module, exports) {

var $917iu = parcelRequire("917iu");

var $62guz = parcelRequire("62guz");

var $46541210f2cd2241$export$264ad599d7cef668 = /*#__PURE__*/ function(Product) {
    Product["Confluence"] = "Confluence";
    Product["Jira"] = "Jira";
    return Product;
}({});
var $46541210f2cd2241$export$e7ac28e9b7e0fa6b = /*#__PURE__*/ function(UpgradeModalComponent) {
    // Pre-upgrade modals
    UpgradeModalComponent["ConfluenceStandardOfferAIModal"] = "ConfluenceStandardOfferAIModal";
    UpgradeModalComponent["ConfluenceStandardOfferCalendarModal"] = "ConfluenceStandardOfferCalendarModal";
    UpgradeModalComponent["JiraPremiumOfferPlansModal"] = "JiraPremiumOfferPlansModal";
    UpgradeModalComponent["JiraPremiumOfferAIModal"] = "JiraPremiumOfferAIModal";
    // Post-upgrade modals
    UpgradeModalComponent["ConfluenceAfterStandardUpgradeAIModal"] = "ConfluenceAfterStandardUpgradeAIModal";
    UpgradeModalComponent["ConfluenceAfterStandardUpgradeCalendarModal"] = "ConfluenceAfterStandardUpgradeCalendarModal";
    UpgradeModalComponent["JiraAfterPremiumUpgradePlansModal"] = "JiraAfterPremiumUpgradePlansModal";
    UpgradeModalComponent["JiraAfterPremiumUpgradeAIModal"] = "JiraAfterPremiumUpgradeAIModal";
    // Common
    UpgradeModalComponent["None"] = "None";
    return UpgradeModalComponent;
}({});
const $46541210f2cd2241$var$DAYS_BETWEEN_MODALS = 10;
const $46541210f2cd2241$var$REACT_RERENDER_GRACE_PERIOD_MS = 1500;
const $46541210f2cd2241$export$5aae9b6b3e0e7094 = {
    ["Confluence"]: {
        first: 'atl-UPFTConfluenceStandardOfferAIModalTimestamp',
        second: 'atl-UPFTConfluenceStandardOfferCalendarModalTimestamp'
    },
    ["Jira"]: {
        first: 'atl-UPFTJiraPremiumOfferPlansModalTimestamp',
        second: 'atl-UPFTJiraPremiumOfferAIModalTimestamp'
    }
};
const $46541210f2cd2241$var$MODAL_COMPONENTS = {
    ["Confluence"]: {
        first: "ConfluenceStandardOfferAIModal",
        second: "ConfluenceStandardOfferCalendarModal"
    },
    ["Jira"]: {
        first: "JiraPremiumOfferPlansModal",
        second: "JiraPremiumOfferAIModal"
    }
};
function $46541210f2cd2241$export$56827b0f9acb5eb6(storageAdapter, product) {
    const now = Date.now();
    const key = $46541210f2cd2241$export$5aae9b6b3e0e7094[product].first;
    storageAdapter.set(key, now.toString());
}
function $46541210f2cd2241$export$3db90d01fbee20b8(storageAdapter, product) {
    const now = Date.now();
    const key = $46541210f2cd2241$export$5aae9b6b3e0e7094[product].second;
    storageAdapter.set(key, now.toString());
}
function $46541210f2cd2241$export$a4fa8a3c39d1ff99(storageAdapter, product) {
    const firstModalTimestamp = storageAdapter.get($46541210f2cd2241$export$5aae9b6b3e0e7094[product].first);
    const secondModalTimestamp = storageAdapter.get($46541210f2cd2241$export$5aae9b6b3e0e7094[product].second);
    if (product === "Confluence") {
        // If user saw both modals, show Calendar post-upgrade modal
        if (firstModalTimestamp && secondModalTimestamp) return "ConfluenceAfterStandardUpgradeCalendarModal";
        // If user only saw first modal (AI), show AI post-upgrade modal
        if (firstModalTimestamp) return "ConfluenceAfterStandardUpgradeAIModal";
    } else if (product === "Jira") {
        // If user saw second modal (AI), show AI post-upgrade modal
        if (secondModalTimestamp) return "JiraAfterPremiumUpgradeAIModal";
        // If user only saw first modal (Plans), show Plans post-upgrade modal
        if (firstModalTimestamp) return "JiraAfterPremiumUpgradePlansModal";
    }
    // If user hasn't seen any modals, don't show post-upgrade modal
    return "None";
}
const $46541210f2cd2241$export$294df3161c8c97de = (timestamp)=>{
    const time = parseInt(timestamp, 10);
    return (0, $62guz.default)(Date.now(), new Date(time)) < $46541210f2cd2241$var$REACT_RERENDER_GRACE_PERIOD_MS;
};
function $46541210f2cd2241$export$bceb56457749f771(storageAdapter, product) {
    const firstModalTimestamp = storageAdapter.get($46541210f2cd2241$export$5aae9b6b3e0e7094[product].first);
    const secondModalTimestamp = storageAdapter.get($46541210f2cd2241$export$5aae9b6b3e0e7094[product].second);
    // If second modal has been shown and enough time has passed to avoid React re-render issues
    if (secondModalTimestamp) // Show second modal if within grace period, otherwise flow is complete
    return $46541210f2cd2241$export$294df3161c8c97de(secondModalTimestamp) ? $46541210f2cd2241$var$MODAL_COMPONENTS[product].second : "None";
    // If first modal has never been shown, show the first modal
    if (!firstModalTimestamp) return $46541210f2cd2241$var$MODAL_COMPONENTS[product].first;
    // If first modal is within grace period of React re-rendering, keep showing it
    if ($46541210f2cd2241$export$294df3161c8c97de(firstModalTimestamp)) return $46541210f2cd2241$var$MODAL_COMPONENTS[product].first;
    // Check if enough days have passed for second modal
    const firstModalTime = parseInt(firstModalTimestamp, 10);
    const daysSinceFirstModal = (0, $917iu.default)(Date.now(), new Date(firstModalTime));
    return daysSinceFirstModal >= $46541210f2cd2241$var$DAYS_BETWEEN_MODALS ? $46541210f2cd2241$var$MODAL_COMPONENTS[product].second : "None";
}
module.exports["Product"] = $46541210f2cd2241$export$264ad599d7cef668;
module.exports["UpgradeModalComponent"] = $46541210f2cd2241$export$e7ac28e9b7e0fa6b;
module.exports["STORAGE_KEYS"] = $46541210f2cd2241$export$5aae9b6b3e0e7094;
module.exports["recordFirstModalShown"] = $46541210f2cd2241$export$56827b0f9acb5eb6;
module.exports["recordSecondModalShown"] = $46541210f2cd2241$export$3db90d01fbee20b8;
module.exports["getPostUpgradeModalToShowForUpgradeFreePoolTargetExperiment"] = $46541210f2cd2241$export$a4fa8a3c39d1ff99;
module.exports["isWithinGracePeriod"] = $46541210f2cd2241$export$294df3161c8c97de;
module.exports["getModalToShow"] = $46541210f2cd2241$export$bceb56457749f771;

});

parcelRegister("2v0M9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3pfAb = parcelRequire("3pfAb");


var $inPa6 = parcelRequire("inPa6");


var $8hmrm = parcelRequire("8hmrm");

var $gwZbZ = parcelRequire("gwZbZ");

var $6o7wX = parcelRequire("6o7wX");

const $a8eff39aacb1f054$var$ANALYTICS_CHANNEL = (0, $3pfAb.FabricChannel).growth;
const $a8eff39aacb1f054$var$GROWTH_INITIATIVE = 'growth-luna';
const $a8eff39aacb1f054$var$CONFLUENCE_EXPERIMENT_KEY = 'twcg-206_confluence_upgrade_permanent_free';
const $a8eff39aacb1f054$var$JIRA_EXPERIMENT_KEY = 'twcg-206_jira_upgrade_permanent_free'; // needs to be created in Switcheroo
const $a8eff39aacb1f054$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sendAnalyticEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire($a8eff39aacb1f054$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent
    ]);
    const clickedDismissModal = (source, analyticsAttributes)=>sendAnalyticEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'dismissUpgradeFreePoolTargetExperimentModal',
            product: 'growth',
            tags: 'growth',
            source: source,
            attributes: {
                growthInitiative: $a8eff39aacb1f054$var$GROWTH_INITIATIVE,
                ...analyticsAttributes
            }
        });
    const clickedPrimaryCTAOnModal = (source, analyticsAttributes)=>sendAnalyticEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'upgradeFreePoolTargetExperimentModal',
            product: 'growth',
            tags: 'growth',
            source: source,
            attributes: {
                growthInitiative: $a8eff39aacb1f054$var$GROWTH_INITIATIVE,
                ...analyticsAttributes
            }
        });
    const growthErrorHandler = ({ error: error, errorInfo: errorInfo, product: product, source: source })=>sendAnalyticEvent((0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
            team: (0, $6o7wX.Team).GROWTH_LUNA,
            product: product === 'confluence' ? (0, $gwZbZ.Product).CONFLUENCE : (0, $gwZbZ.Product).JIRA,
            experimentMeta: {
                experimentKey: product === 'confluence' ? $a8eff39aacb1f054$var$CONFLUENCE_EXPERIMENT_KEY : $a8eff39aacb1f054$var$JIRA_EXPERIMENT_KEY
            },
            errorMessage: error.message,
            errorType: (0, $gwZbZ.ErrorType).GENERIC,
            source: source || (product === 'confluence' ? $a8eff39aacb1f054$var$CONFLUENCE_EXPERIMENT_KEY : $a8eff39aacb1f054$var$JIRA_EXPERIMENT_KEY),
            severity: (0, $gwZbZ.Severity).HIGH,
            additionalAttributes: {
                ...errorInfo
            }
        }));
    return {
        sendAnalyticEvent: sendAnalyticEvent,
        clickedDismissModal: clickedDismissModal,
        clickedPrimaryCTAOnModal: clickedPrimaryCTAOnModal,
        growthErrorHandler: growthErrorHandler
    };
};
const $a8eff39aacb1f054$export$b901544a79a3bbad = ({ name: name, attributes: attributes })=>{
    const { sendAnalyticEvent: sendAnalyticEvent } = $a8eff39aacb1f054$export$e955abb82869dc84();
    const hasSentScreenEvent = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasSentScreenEvent.current) return;
        sendAnalyticEvent({
            eventType: 'screen',
            name: name,
            attributes: attributes
        });
    }, [
        sendAnalyticEvent,
        name,
        attributes
    ]);
    return null;
};
module.exports["useAnalytics"] = $a8eff39aacb1f054$export$e955abb82869dc84;
module.exports["ScreenEvent"] = $a8eff39aacb1f054$export$b901544a79a3bbad;

});

parcelRegister("aamGC", function(module, exports) {
const $a51bb093384df545$export$cd89c3d426a934d9 = 'ConfluenceStandardOfferAIModal';
const $a51bb093384df545$export$7840530d75fdf1bb = 'ConfluenceStandardOfferCalendarModal';
const $a51bb093384df545$export$24a08eb73edff915 = 'ConfluenceAfterStandardUpgradeAIModal';
const $a51bb093384df545$export$cfe5c37b062d9000 = 'ConfluenceAfterStandardUpgradeCalendarModal';
const $a51bb093384df545$export$8154d097362cdcc2 = 'JiraPremiumOfferAIModal';
const $a51bb093384df545$export$9838bd7fadc5a303 = 'JiraPremiumPlansModal';
module.exports["CONFLUENCE_STANDARD_OFFER_AI_MODAL"] = $a51bb093384df545$export$cd89c3d426a934d9;
module.exports["CONFLUENCE_STANDARD_OFFER_CALENDAR_MODAL"] = $a51bb093384df545$export$7840530d75fdf1bb;
module.exports["CONFLUENCE_AFTER_STANDARD_UPGRADE_AI_MODAL"] = $a51bb093384df545$export$24a08eb73edff915;
module.exports["CONFLUENCE_AFTER_STANDARD_UPGRADE_CALENDAR_MODAL"] = $a51bb093384df545$export$cfe5c37b062d9000;

});

parcelRegister("0JTlo", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $eb324d2f17350877$export$baa48889c42cc6cb = ()=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(true);
    const handleClose = ()=>{
        setIsOpen(false);
    };
    return {
        isOpen: isOpen,
        handleClose: handleClose
    };
};
module.exports["useModalState"] = $eb324d2f17350877$export$baa48889c42cc6cb;

});

parcelRegister("hWVhC", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $h7YX1 = parcelRequire("h7YX1");


var $gNXND = parcelRequire("gNXND");


var $a6IPc = parcelRequire("a6IPc");


var $gj7hi = parcelRequire("gj7hi");


var $lAFHW = parcelRequire("lAFHW");


var $iJUOw = parcelRequire("iJUOw");

var $eb4a4c2269471168$exports = {};
$eb4a4c2269471168$exports = new URL("ConfluenceStandardOfferAIModalRightSide.7551cf90.svg", import.meta.url).toString();


var $43e3680bac7087ec$exports = {};
$43e3680bac7087ec$exports = new URL("ConfluenceStandardOfferAIModalRightSideDark.4c810671.svg", import.meta.url).toString();



var $2v0M9 = parcelRequire("2v0M9");


var $aamGC = parcelRequire("aamGC");


var $0JTlo = parcelRequire("0JTlo");


var $1xVJk = parcelRequire("1xVJk");


var $mSdG9 = parcelRequire("mSdG9");


var $ewngD = parcelRequire("ewngD");


var $cgtv4 = parcelRequire("cgtv4");

const $3119a1bdb9120cbd$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    standardOfferAITitle: {
        id: "upgrade-free-pool-target-experiment.Confluence-Standard-Offer-AI-Modal.title",
        defaultMessage: "Work smarter, not harder"
    },
    standardOfferAISubtitle: {
        id: "upgrade-free-pool-target-experiment.Confluence-Standard-Offer-AI-Modal.subtitle",
        defaultMessage: "Leave the busywork to AI - summarize content, turn notes into docs, and more. Try Standard free for 14 days."
    },
    aiBenefitsNotesToDocs: {
        id: "upgrade-free-pool-target-experiment.Confluence-Standard-Offer-AI-Modal.aiBenefitsNotesToDocs",
        defaultMessage: "Turn messy notes into polished docs"
    },
    aiBenefitsSummarizePages: {
        id: "upgrade-free-pool-target-experiment.Confluence-Standard-Offer-AI-Modal.aiBenefitsSummarizePages",
        defaultMessage: "Summarize and catch up on pages"
    },
    aiBenefitsFindInformation: {
        id: "upgrade-free-pool-target-experiment.Confluence-Standard-Offer-AI-Modal.aiBenefitsFindInformation",
        defaultMessage: "Find information and get answers, fast"
    },
    standardOfferAIDisclaimerText: {
        id: "upgrade-free-pool-target-experiment.Confluence-Standard-Offer-AI-Modal.disclaimerText",
        defaultMessage: "Free 14-day Standard plan trial. Cancel or downgrade anytime. We\u2019ll remind you before your trial ends."
    },
    standardOfferAIPrimaryCTA: {
        id: "upgrade-free-pool-target-experiment.Confluence-Standard-Offer-AI-Modal.primaryCTA",
        defaultMessage: "Try it free"
    },
    standardOfferAISecondaryCTA: {
        id: "upgrade-free-pool-target-experiment.Confluence-Standard-Offer-AI-Modal.secondaryCTA",
        defaultMessage: "Not now"
    }
});


const $3630425c42cf4c7a$export$1715ff5f6a8719bb = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eb4a4c2269471168$exports))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($43e3680bac7087ec$exports))),
        alt: "Onboarding Strategy"
    });
const $3630425c42cf4c7a$export$efeaae12919a0881 = ({ analyticsAttributes: analyticsAttributes, experienceUrl: experienceUrl })=>{
    const intl = (0, $8C5kA.default)();
    const { isOpen: isOpen, handleClose: handleClose } = (0, $0JTlo.useModalState)();
    const componentAttributes = {
        ...analyticsAttributes,
        product: 'confluence',
        offerShown: 'AI',
        modalShownPrePostUpgrade: 'PRE_UPGRADE'
    };
    const { clickedDismissModal: clickedDismissModal, clickedPrimaryCTAOnModal: clickedPrimaryCTAOnModal } = (0, $2v0M9.useAnalytics)();
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $iJUOw.Modal), {
        height: "560px",
        logo: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceLogo), {
            shouldUseNewLogoDesign: true,
            size: "xsmall"
        }),
        title: intl.formatMessage((0, $3119a1bdb9120cbd$export$defe85febe8b728c).standardOfferAITitle),
        subtitle: intl.formatMessage((0, $3119a1bdb9120cbd$export$defe85febe8b728c).standardOfferAISubtitle),
        testId: "growth-pattern-library-modal",
        onClose: ()=>{
            clickedDismissModal((0, $aamGC.CONFLUENCE_STANDARD_OFFER_AI_MODAL), {
                ...componentAttributes,
                dismissalMethod: 'modalOverlayClick'
            });
            handleClose();
        },
        sideContent: (0, $ewngD.SideContentWithModalCloseButton)(/*#__PURE__*/ (0, $l998X.jsx)($3630425c42cf4c7a$export$1715ff5f6a8719bb, {}), ()=>{
            clickedDismissModal((0, $aamGC.CONFLUENCE_STANDARD_OFFER_AI_MODAL), {
                ...componentAttributes,
                dismissalMethod: 'closeButton'
            });
            handleClose();
        }),
        actions: /*#__PURE__*/ (0, $l998X.jsx)((0, $mSdG9.PrimaryAndSecondaryCTAActionsGroup), {
            secondaryCTALabel: intl.formatMessage((0, $3119a1bdb9120cbd$export$defe85febe8b728c).standardOfferAISecondaryCTA),
            onSecondaryCTAClick: ()=>{
                clickedDismissModal((0, $aamGC.CONFLUENCE_STANDARD_OFFER_AI_MODAL), {
                    ...componentAttributes,
                    dismissalMethod: 'secondaryCTAButton'
                });
                handleClose();
            },
            primaryCTALabel: intl.formatMessage((0, $3119a1bdb9120cbd$export$defe85febe8b728c).standardOfferAIPrimaryCTA),
            onPrimaryCTAClick: ()=>{
                clickedPrimaryCTAOnModal((0, $aamGC.CONFLUENCE_STANDARD_OFFER_AI_MODAL), {
                    ...componentAttributes,
                    changeOfferingUrl: '' // TODO to add in LUNA-615
                });
            },
            href: experienceUrl,
            isLoading: false
        }),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1xVJk.EditionHighlightsLeftContent), {
                highlights: [
                    {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($h7YX1))),
                        title: intl.formatMessage((0, $3119a1bdb9120cbd$export$defe85febe8b728c).aiBenefitsNotesToDocs)
                    },
                    {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($a6IPc))),
                        title: intl.formatMessage((0, $3119a1bdb9120cbd$export$defe85febe8b728c).aiBenefitsSummarizePages)
                    },
                    {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gNXND))),
                        title: intl.formatMessage((0, $3119a1bdb9120cbd$export$defe85febe8b728c).aiBenefitsFindInformation)
                    }
                ],
                disclaimerText: intl.formatMessage((0, $3119a1bdb9120cbd$export$defe85febe8b728c).standardOfferAIDisclaimerText)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2v0M9.ScreenEvent), {
                name: "upgradeFreePoolTargetExperimentModal",
                attributes: componentAttributes
            })
        ]
    });
};
module.exports["StandardOfferAIModalRightSide"] = $3630425c42cf4c7a$export$1715ff5f6a8719bb;
module.exports["ConfluenceStandardOfferAIModal"] = $3630425c42cf4c7a$export$efeaae12919a0881;

});

parcelRegister("1xVJk", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");

const $1ea047e0377c1db8$var$styles = {
    featureRow: "_ca0qu2gc _n3tdu2gc",
    disclaimer: "_ca0q1ejb"
};
const $1ea047e0377c1db8$export$336651ea82b4f539 = ({ disclaimerText: disclaimerText, highlights: highlights })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                direction: "column",
                children: highlights?.map((highlight)=>{
                    const { title: title, icon: IconComponent } = highlight;
                    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                        gap: "space.150",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {
                                color: "var(--ds-icon-brand, #0C66E4)",
                                label: ""
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $1ea047e0377c1db8$var$styles.featureRow,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    color: "color.text.subtle",
                                    children: title
                                })
                            })
                        ]
                    });
                })
            }),
            disclaimerText && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $1ea047e0377c1db8$var$styles.disclaimer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: "color.text.subtlest",
                    size: "small",
                    children: disclaimerText
                })
            })
        ]
    });
};
module.exports["EditionHighlightsLeftContent"] = $1ea047e0377c1db8$export$336651ea82b4f539;

});

parcelRegister("mSdG9", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $ccHMk = parcelRequire("ccHMk");

var $7p4As = parcelRequire("7p4As");


var $9hlns = parcelRequire("9hlns");

const $11e7b0e676740a14$export$79443df52fa9e3c9 = ({ secondaryCTALabel: secondaryCTALabel, onSecondaryCTAClick: onSecondaryCTAClick, primaryCTALabel: primaryCTALabel, onPrimaryCTAClick: onPrimaryCTAClick, href: href, isLoading: isLoading })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                appearance: "subtle",
                onClick: onSecondaryCTAClick,
                children: secondaryCTALabel
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
                href: href ?? '',
                appearance: "primary",
                target: "_blank",
                isDisabled: isLoading,
                onClick: onPrimaryCTAClick,
                color: "brand",
                children: isLoading ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                    size: "small",
                    label: "Loading"
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                    children: primaryCTALabel
                })
            })
        ]
    });
};
module.exports["PrimaryAndSecondaryCTAActionsGroup"] = $11e7b0e676740a14$export$79443df52fa9e3c9;

});

parcelRegister("ewngD", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8TTLA = parcelRequire("8TTLA");


var $gdv5Z = parcelRequire("gdv5Z");

const $29318204efa629b7$var$styles = {
    rightSide: "_1reo15vq _18m915vq _kqswh2mm _1e0c11hb",
    button: "_kqswstnw _154iv47k _1xi2v47k"
};
const $29318204efa629b7$export$8a549b2b1be83005 = (component, onClickHandler)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $29318204efa629b7$var$styles.rightSide,
        children: [
            component,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $29318204efa629b7$var$styles.button,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8TTLA.CloseButton), {
                    testId: "upft-experiment-modal",
                    onClick: onClickHandler
                })
            })
        ]
    });
};
module.exports["SideContentWithModalCloseButton"] = $29318204efa629b7$export$8a549b2b1be83005;

});

parcelRegister("6km2F", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $6uENn = parcelRequire("6uENn");


var $c8wfa = parcelRequire("c8wfa");


var $iNP4c = parcelRequire("iNP4c");


var $gj7hi = parcelRequire("gj7hi");


var $lAFHW = parcelRequire("lAFHW");


var $iJUOw = parcelRequire("iJUOw");

var $b5928db417c7765d$exports = {};
$b5928db417c7765d$exports = new URL("ConfluenceStandardOfferCalendarModalRightSide.cde5ac5e.svg", import.meta.url).toString();


var $ff127f1aaf07df83$exports = {};
$ff127f1aaf07df83$exports = new URL("ConfluenceStandardOfferCalendarModalRightSideDark.315b1cd5.svg", import.meta.url).toString();



var $2v0M9 = parcelRequire("2v0M9");


var $aamGC = parcelRequire("aamGC");


var $0JTlo = parcelRequire("0JTlo");


var $1xVJk = parcelRequire("1xVJk");


var $mSdG9 = parcelRequire("mSdG9");


var $ewngD = parcelRequire("ewngD");


var $cgtv4 = parcelRequire("cgtv4");

const $c7005cf06264fc28$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    standardOfferCalendarTitle: {
        id: "upgrade-free-pool-target-experiment.Standard-Offer-Calendar-Modal.title",
        defaultMessage: "Balance deadlines and downtime"
    },
    standardOfferCalendarSubtitle: {
        id: "upgrade-free-pool-target-experiment.Standard-Offer-Calendar-Modal.subtitle",
        defaultMessage: "Bring schedules and work together with team calendars. Try Standard free for 14 days."
    },
    calendarBenefitsTrack: {
        id: "upgrade-free-pool-target-experiment.Standard-Offer-Calendar-Modal.calendarBenefitsTrack",
        defaultMessage: "Track who's doing what and when"
    },
    calendarBenefitsSeeDeadlines: {
        id: "upgrade-free-pool-target-experiment.Standard-Offer-Calendar-Modal.calendarBenefitsSeeDeadlines",
        defaultMessage: "See deadlines alongside key events"
    },
    calendarBenefitsLinkEvents: {
        id: "upgrade-free-pool-target-experiment.Standard-Offer-Calendar-Modal.calendarBenefitsLinkEvents",
        defaultMessage: "Link events to spaces and pages"
    },
    standardOfferCalendarDisclaimerText: {
        id: "upgrade-free-pool-target-experiment.Standard-Offer-Calendar-Modal.disclaimerText",
        defaultMessage: "Free 14-day Standard plan trial. Cancel or downgrade anytime. We\u2019ll remind you before your trial ends."
    },
    standardOfferCalendarPrimaryCTA: {
        id: "upgrade-free-pool-target-experiment.Standard-Offer-Calendar-Modal.primaryCTA",
        defaultMessage: "Try it free"
    },
    standardOfferCalendarSecondaryCTA: {
        id: "upgrade-free-pool-target-experiment.Standard-Offer-Calendar-Modal.secondaryCTA",
        defaultMessage: "Not now"
    }
});


const $3c6e2fec5beec9f2$export$f4953e443029121b = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b5928db417c7765d$exports))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($ff127f1aaf07df83$exports))),
        alt: "Calendars"
    });
const $3c6e2fec5beec9f2$export$4a759397b45780da = ({ analyticsAttributes: analyticsAttributes, experienceUrl: experienceUrl })=>{
    const intl = (0, $8C5kA.default)();
    const { isOpen: isOpen, handleClose: handleClose } = (0, $0JTlo.useModalState)();
    const componentAttributes = {
        ...analyticsAttributes,
        product: 'confluence',
        offerShown: 'CALENDAR',
        modalShownPrePostUpgrade: 'PRE_UPGRADE'
    };
    const { clickedDismissModal: clickedDismissModal, clickedPrimaryCTAOnModal: clickedPrimaryCTAOnModal } = (0, $2v0M9.useAnalytics)();
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $iJUOw.Modal), {
        height: "560px",
        logo: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceLogo), {
            shouldUseNewLogoDesign: true,
            size: "xsmall"
        }),
        title: intl.formatMessage((0, $c7005cf06264fc28$export$defe85febe8b728c).standardOfferCalendarTitle),
        subtitle: intl.formatMessage((0, $c7005cf06264fc28$export$defe85febe8b728c).standardOfferCalendarSubtitle),
        testId: "growth-pattern-library-modal",
        onClose: ()=>{
            clickedDismissModal((0, $aamGC.CONFLUENCE_STANDARD_OFFER_CALENDAR_MODAL), {
                ...componentAttributes,
                dismissalMethod: 'modalOverlayClick'
            });
            handleClose();
        },
        sideContent: (0, $ewngD.SideContentWithModalCloseButton)(/*#__PURE__*/ (0, $l998X.jsx)($3c6e2fec5beec9f2$export$f4953e443029121b, {}), ()=>{
            clickedDismissModal((0, $aamGC.CONFLUENCE_STANDARD_OFFER_CALENDAR_MODAL), {
                ...componentAttributes,
                dismissalMethod: 'closeButton'
            });
            handleClose();
        }),
        actions: /*#__PURE__*/ (0, $l998X.jsx)((0, $mSdG9.PrimaryAndSecondaryCTAActionsGroup), {
            secondaryCTALabel: intl.formatMessage((0, $c7005cf06264fc28$export$defe85febe8b728c).standardOfferCalendarSecondaryCTA),
            onSecondaryCTAClick: ()=>{
                clickedDismissModal((0, $aamGC.CONFLUENCE_STANDARD_OFFER_CALENDAR_MODAL), {
                    ...componentAttributes,
                    dismissalMethod: 'secondaryCTAButton'
                });
                handleClose();
            },
            primaryCTALabel: intl.formatMessage((0, $c7005cf06264fc28$export$defe85febe8b728c).standardOfferCalendarPrimaryCTA),
            onPrimaryCTAClick: ()=>{
                clickedPrimaryCTAOnModal((0, $aamGC.CONFLUENCE_STANDARD_OFFER_CALENDAR_MODAL), {
                    ...componentAttributes,
                    changeOfferingUrl: '' // TODO to add in LUNA-615
                });
            },
            href: experienceUrl,
            isLoading: false
        }),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1xVJk.EditionHighlightsLeftContent), {
                highlights: [
                    {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6uENn))),
                        title: intl.formatMessage((0, $c7005cf06264fc28$export$defe85febe8b728c).calendarBenefitsTrack)
                    },
                    {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c8wfa))),
                        title: intl.formatMessage((0, $c7005cf06264fc28$export$defe85febe8b728c).calendarBenefitsSeeDeadlines)
                    },
                    {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iNP4c))),
                        title: intl.formatMessage((0, $c7005cf06264fc28$export$defe85febe8b728c).calendarBenefitsLinkEvents)
                    }
                ],
                disclaimerText: intl.formatMessage((0, $c7005cf06264fc28$export$defe85febe8b728c).standardOfferCalendarDisclaimerText)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2v0M9.ScreenEvent), {
                name: "upgradeFreePoolTargetExperimentModal",
                attributes: componentAttributes
            })
        ]
    });
};
module.exports["StandardOfferCalendarModalRightSide"] = $3c6e2fec5beec9f2$export$f4953e443029121b;
module.exports["ConfluenceStandardOfferCalendarModal"] = $3c6e2fec5beec9f2$export$4a759397b45780da;

});

parcelRegister("a7QKb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8hmrm = parcelRequire("8hmrm");

var $gwZbZ = parcelRequire("gwZbZ");

var $6o7wX = parcelRequire("6o7wX");


var $inPa6 = parcelRequire("inPa6");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");

const $f8b6d05bed69a46f$export$c08161ba6e1751b6 = ({ children: children, experimentKey: experimentKey, source: source, cohort: cohort, additionalAttributes: additionalAttributes = {} })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH_LUNA,
        onError: (error, info)=>{
            const eventPayload = (0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
                product: (0, $gwZbZ.Product).CONFLUENCE,
                team: (0, $6o7wX.Team).GROWTH_LUNA,
                experimentMeta: {
                    experimentKey: experimentKey,
                    ...cohort && {
                        cohort: cohort
                    }
                },
                errorType: (0, $gwZbZ.ErrorType).ERROR_BOUNDARY,
                errorMessage: error.message,
                severity: (0, $gwZbZ.Severity).MEDIUM,
                source: source,
                additionalAttributes: {
                    ...info,
                    ...additionalAttributes,
                    errorStack: error.stack
                }
            });
            createAnalyticsEvent(eventPayload).fire();
        }
    }, children);
};
module.exports["ExperimentErrorBoundaryWrapper"] = $f8b6d05bed69a46f$export$c08161ba6e1751b6;

});


//# sourceMappingURL=base-component.fcef5d0b.js.map
